import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Alert,
} from "@mui/material";
import UserDialog from "./components/UserDialog";
import StudyDropDown from "../../common/components/StudyDropDown";
import { useGetUsersQuery } from "../../api/useGetUsers";
import UserEditDialog from "./components/UserEditDialog";
import { useDeleteUserQuery } from "../../api/useDeleteUser";
import UserPasswordDialog from "./components/UserPasswordDialog";

const studies = ["React", "Node.js", "Python"];

const AdminUserPage = () => {
  const [apiSearchTerm, setApiSearchTerm] = React.useState("");

  const [searchTerm, setSearchTerm] = React.useState("");
  const [selectedStudy, setSelectedStudy] = React.useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isPwModalOpen, setIsPwModalOpen] = useState(false);
  const [pwData, setPwData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [editData, setEditData] = useState(null);
  const { mutate: deleteUser } = useDeleteUserQuery();
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const openEditModal = () => setIsEditModalOpen(true);
  const closeEditModal = () => {
    setEditData(null);
    setIsEditModalOpen(false);
  };
  const openPwModal = () => setIsPwModalOpen(true);
  const closePwModal = () => {
    setPwData(null);
    setIsPwModalOpen(false);
  };
  const {
    data: students,
    isLoading,
    isError,
    error,
  } = useGetUsersQuery({ studyId: selectedStudy._id, keyword: apiSearchTerm });
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const search = (event) => {
    setApiSearchTerm(searchTerm);
  };
  const handleEditClick = (user) => {
    setEditData(user);
    openEditModal();
  };
  const handlePwClick = (user) => {
    setPwData(user);
    openPwModal();
  };
  const handleStudyChange = (event) => {
    setSelectedStudy(event.target.value);
  };
  const handleNewUser = () => {
    setEditData(null);
    openModal();
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      search();
    }
  };
  const handleDeleteClick = (userId) => {
    if (window.confirm("삭제하시겠습니까?")) {
      deleteUser(userId);
    }
  };

  if (isLoading) {
    return <div>loading...</div>;
  }
  if (isError) {
    setErrorMessage(error.response.data.message);
  }
  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6}>
          <StudyDropDown
            selectedStudy={selectedStudy}
            handleStudyChange={handleStudyChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="이름 또는 이메일 검색"
            variant="outlined"
            value={searchTerm}
            onChange={handleSearchChange}
            onKeyDown={handleKeyPress}
          />
        </Grid>

        <Grid item sm={2} xs={12}>
          <Button variant="contained" fullWidth onClick={handleNewUser}>
            학생 추가
          </Button>
        </Grid>
      </Grid>
      {isError ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMessage}
        </Alert>
      ) : (
        <TableContainer component={Paper} sx={{ marginTop: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>이름</TableCell>
                <TableCell>이메일</TableCell>
                <TableCell>지역</TableCell>
                <TableCell>스터디 리스트</TableCell>
                <TableCell>가입여부</TableCell>
                <TableCell>비밀번호 수정</TableCell>
                <TableCell>수정/삭제</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {students.map((student) => (
                <TableRow key={student.email}>
                  <TableCell>{student.name}</TableCell>
                  <TableCell>{student.email}</TableCell>
                  <TableCell>{student.region}</TableCell>
                  <TableCell>
                    {student.studyList.map((study) => study.title).join(", ")}
                  </TableCell>
                  <TableCell>
                    {student.isSignUp ? "가입완료" : "가입안함"}
                  </TableCell>
                  <TableCell>
                    <Button size="small" onClick={() => handlePwClick(student)}>
                      비번 재설정
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Button
                      size="small"
                      onClick={() => handleEditClick(student)}
                    >
                      수정
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      onClick={() => handleDeleteClick(student._id)}
                    >
                      삭제
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <UserDialog isModalOpen={isModalOpen} closeModal={closeModal} />
      <UserEditDialog
        isModalOpen={isEditModalOpen}
        closeModal={closeEditModal}
        data={editData}
      />
      <UserPasswordDialog
        isModalOpen={isPwModalOpen}
        closeModal={closePwModal}
        data={pwData}
      />
    </Box>
  );
};

export default AdminUserPage;
